
namespace GeniuzPOS.Member {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class ReportMemberConditionDialog extends Serenity.EntityDialog<ReportMemberConditionRow, any> {
        protected getFormKey() { return ReportMemberConditionForm.formKey; }
        protected getIdProperty() { return ReportMemberConditionRow.idProperty; }
        protected getLocalTextPrefix() { return ReportMemberConditionRow.localTextPrefix; }
        protected getNameProperty() { return ReportMemberConditionRow.nameProperty; }
        protected getService() { return ReportMemberConditionService.baseUrl; }
        protected getDeletePermission() { return ReportMemberConditionRow.deletePermission; }
        protected getInsertPermission() { return ReportMemberConditionRow.insertPermission; }
        protected getUpdatePermission() { return ReportMemberConditionRow.updatePermission; }

        protected form = new ReportMemberConditionForm(this.idPrefix);
        

        protected initToolbar() {
            super.initToolbar();

        }
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'save-and-close-button'), 1)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'delete-button'), 1)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'apply-changes-button'), 1)
           
            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();
                        // *** do something on click if you want **

                    },
                }
            );

            return buttons;
        }
        protected beforeLoadEntity() {          
            

        }
        protected afterLoadEntity() {
            super.afterLoadEntity();
            

        }


       
    }
}